module.exports = __webpack_public_path__ + "img/03.ef7ceac4.jpg";